import * as types from '../mutation-types'
import http from '@/plugins/axios'
import router from '@/router'

const format = data => {
  data.forEach(item => {
    item.children &&
      (item.children.length === 0
        ? delete item.children
        : format(item.children))
  })
}

const state = {
  menus: {},
  path: '',
  user: null,
  cookie: '',
  people: [],
  jobs: [],
  departments: [],
  channels: [],
  resume: {
    id: '',
    operable: false
  },
  resume_status_enum: [
    {
      value: '-1',
      label: '删除'
    },
    {
      value: '0',
      label: '未处理'
    },
    {
      value: '1',
      label: '可邀约'
    },
    {
      value: '2',
      label: '不合适'
    },
    {
      value: '3',
      label: '已邀约'
    },
    {
      value: '4',
      label: '爽约'
    },
    {
      value: '5',
      label: '已面试'
    },
    {
      value: '6',
      label: '通过'
    },
    {
      value: '7',
      label: '发offer'
    },
    {
      value: '8',
      label: '放弃入职'
    },
    {
      value: '9',
      label: '入职'
    },
    {
      value: '10',
      label: '上传'
    },
    {
      value: '11',
      label: '内推'
    },
    {
      value: '12',
      label: '邀约失败'
    },
    {
      value: '-2',
      label: '不通过'
    },
    {
      value: '-3',
      label: '人才库'
    },
    {
      value: '10001',
      label: '修改'
    }
  ],
  previllage: 1,
  crumbSecond: []
}

const getters = {
  loggedIn: state => state.user !== null
}

const actions = {
  login: async ({ commit }, payload) => {
    const res = await http.post('auth/submit2', payload)
    if (res.successful) {
      const menuRes = await http.post('/home')
      // console.log(menuRes)
      // menuRes.data.mobile = 1  //如果需要本地开发，在这里先写左边菜单路由，等本地开发完，在注释上线
      commit(types.RECORD_GLOBAL_MENUS, menuRes.data)
      commit(types.RECORD_GLOBAL_USER, res.data.user_name)
      commit(types.RECORD_GLOBAL_COOKIE, res.data.cookie)
    }
    return res
  },
  quit: ({ commit }) => {
    router.push('/')
    commit(types.RECORD_GLOBAL_USER, null)
    commit(types.RECORD_GLOBAL_COOKIE, '')
  },
  logout: ({ commit }) => {
    http.post('logout', { a: 1 }).then(res => {
      if (res && res.status === 200) {
        router.push('/')
        commit(types.RECORD_GLOBAL_USER, null)
        commit(types.RECORD_GLOBAL_COOKIE, '')
      }
    })
  },
  fetchPeople: async ({ commit, state }) => {
    if (state.people.length === 0) {
      const res = await http.post('yuangong/simple')
      commit(types.RECORD_GLOBAL_PEOPLE, res.data.yuangong_data)
    }
    return state.people
  },
  fetchJobs: async ({ commit, state }) => {
    if (state.jobs.length === 0) {
      const res = await http.post('zhaopin/zhiwei2')
      res.data &&
        commit(
          types.RECORD_GLOBAL_JOBS,
          res.data.zhiwei_data.map(x => {
            return {
              zhiwei_id: x.zhiwei_id,
              zhiwei_name: x.zhiwei_name,
              zhiwei_jibie: x.zhiwei_jibie
            }
          })
        )
    }
    return state.jobs
  },
  fetchDepartments: async ({ commit, state }) => {
    if (state.departments.length === 0) {
      const res = await http.post('jiagou/children')
      format(res.data.data)
      commit(types.RECORD_GLOBAL_DEPARTMENTS, res.data.data)
    }
    return state.departments
  },
  fetchChannels: async ({ commit, state }) => {
    const res = await http.post('/tag/get', { type: 'changjing' })
    format(res.data.data)
    res.data.data.forEach(x => {
      x.value = x.id
      x.children && x.children.forEach(y => {
        y.value = y.id
      })
    })

    commit(types.RECORD_GLOBAL_CHANNELS, res.data.data)
    return state.channels
  }
}

const mutations = {
  [types.RECORD_GLOBAL_USER](state, user) {
    state.user = user
  },
  [types.RECORD_GLOBAL_COOKIE](state, cookie) {
    state.cookie = cookie
  },
  [types.RECORD_GLOBAL_PEOPLE](state, people) {
    state.people = people
  },
  [types.RECORD_GLOBAL_JOBS](state, jobs) {
    state.jobs = jobs
  },
  [types.RECORD_GLOBAL_DEPARTMENTS](state, departments) {
    state.departments = departments
  },
  [types.RECORD_GLOBAL_CHANNELS](state, channels) {
    state.channels = channels
  },
  [types.RECORD_GLOBAL_RESUME](state, resume) {
    state.resume = resume
  },
  [types.RECORD_GLOBAL_PATH] (state, path) {
    state.path = path
  },
  [types.RECORD_GLOBAL_PREVILLAGE](state, previllage) {
    state.previllage = previllage
  },
  [types.RECORD_GLOBAL_MENUS] (state, menus) {
    state.menus = menus
  },
  [types.RECORD_GLOBAL_CRUMBSECOND] (state, crumbs) {
    // 看要追加的crumbs是否存在crumbSecond，不存在则push进数组
    const exists = state.crumbSecond.filter((item) => {
      return item.path === crumbs.path
    })
    exists.length < 1 && state.crumbSecond.push(crumbs)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
